/**
 * ShoppingCart entity class
 */

/**
 * ShoppingCartFactory
 * returns ShoppingCart entity class
 *
 * @class ShoppingCartFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ShoppingCart} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ShoppingCartFactory
 */
/* @ngInject */
export default function ShoppingCartFactory ($http, Entity, alertLiteSvc) {
  /* === ShoppingCart class === */

  /**
   * ShoppingCart model
   *
   * @class ShoppingCart
   * @classdesc ShoppingCart model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.FileUploadMixin
   * @return {models.ShoppingCart} ShoppingCart entity
   */
  function ShoppingCart () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ShoppingCart.prototype = Object.create(Entity.prototype)
  ShoppingCart.prototype.constructor = ShoppingCart

  /* === ShoppingCart instance methods & fields === */

  Object.assign(ShoppingCart.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ShoppingCart#
     * @type {Object}
     */
    _fields: {
      blockAccessForSuspended: Boolean,
      coverImageEnabled: true,
      displayBackupPhoneNumberOnRegistration: Boolean,
      displaySubscriptionsType: 'BY_SUBSCRIPTION',
      enabled: false,
      networkId: Number,
      shoppingCartUrl: String,
      shoppingCartSubscriptionSettings: [{
        active: Boolean,
        amounts: ['Amount'],
        coverImageUrl: String,
        currency: 'Currency',
        description: String,
        dueDate: String,
        heading: String,
        length: Number,
        lengthType: String,
        name: String,
        promoLabel: String,
        periodUnlimited: Boolean,
        subscriptionId: Number,
        sortOrder: Number
      }],
      shoppingCartSubscriptionPlansSettings: ['SubscriptionPlan']
    },

    /**
     * url template
     *
     * @memberof models.ShoppingCart#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/shopping-cart/settings',

    /**
     * public url template
     *
     * @memberof models.ShoppingCart#
     * @type {String}
     */
    _publicUrlTemplate: 'shoppingCart/{{::id}}'
  })

  /**
   * Search tags by param
   *
   * @param {ShoppingCart} sc
   * @param {Number} networkId
   * @returns {Promise} promise
   */
  ShoppingCart.save = function (sc, networkId) {
    if (sc.displaySubscriptionsType === 'BY_SUBSCRIPTION_PLAN') {
      sc.shoppingCartSubscriptionPlansSettings.forEach(plan => {
        plan.subscriptionSettings.forEach((ss, index) => {
          ss.sortOrder = index
        })
      })
    }
    return $http({
      method: 'PUT',
      url: `api/networks/${networkId}/shopping-cart/settings`,
      data: sc
    })
      .data()
      .then((response) => {
        alertLiteSvc.alert('Shopping Cart Settings updated successfully.', 'success')
        return response.payload
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /* === ShoppingCart static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ShoppingCart, Entity)
  ShoppingCart._name = 'ShoppingCart'
  ShoppingCart.init()

  // permissions
  // ShoppingCart.access = {}

  // extra
  // ShoppingCart.extra = {}

  return ShoppingCart
}
